import { AverageTypes, TaxTypes } from "./enums";

export const sectionLabels = {
  taxCheck: "Grundsteuer-Checker",
  rateTest: "Hebesatz-Test",
} as const;

export const inputLabels = {
  clear: "Eingabe löschen",
  info: "Weitere Informationen",
} as const;

export const checkboxLabels = {
  selectAll: "Alle auswählen",
} as const;

export const autosuggestLabels = {
  shortened:
    "Liste gekürzt. Ändern Sie Ihren Suchbegriff für weitere Ergebnisse.",
} as const;

export const filterLabels = {
  state: "Bundesland",
  region: "Kommune",
  years: "Jahre",
  taxes: "Daten",
} as const;

export const taxLabels = {
  [TaxTypes.TAX]: "Aufkommen Grundsteuer B",
  [TaxTypes.TAX_PER_CAPITA]: "Aufkommen Grundsteuer B pro Einwohner",
  [TaxTypes.RATE]: "Hebesatz in %",
} as const;

export const tableLabels = {
  country: "Deutschland",
  increaseLabel: "Zuwachs {start} bis {end} in %",
  increaseNote: "Hinweis zum Zuwachs",
  na: "k. A.",
} as const;

export const averageLabels = {
  [AverageTypes.LARGER_ABOVE_10]:
    "Wert 10% größer als der Durchschnitt des Bundeslandes oder Deutschlands.",
  [AverageTypes.LARGER_BELOW_10]:
    "Wert größer (aber kleiner als 10%) als der Durchschnitt des Bundeslandes oder Deutschlands.",
  [AverageTypes.SMALLER_OR_EQUAL]:
    "Wert nicht größer als der Durchschnitt des Bundeslandes oder Deutschlands.",
};

export const rateLabels = {
  currentTaxLabel: "Wie viel Grundsteuer zahlen Sie derzeit im Jahr?",
  currentTaxInfo:
    "Siehe Grundsteuerbescheid (als Eigentümer) bzw. Betriebskostenabrechnung (als Mieter).",
  measurementAmountLabel: "Wie hoch ist Ihr neuer Grundsteuer-Messbetrag?",
  measurementAmountInfo:
    "Siehe Bescheid über den Grundsteuer-Messbetrag 2025 (als Eigentümer, falls vorliegend) oder <a href='https://grundsteuer.de/rechner/' target='_blank'>Online-Abschätzung</a>.",
  resultLabel:
    "So hoch müsste der Hebesatz Ihrer Kommune im Jahr 2025 sein, damit Sie keine Grundsteuererhöhung erleiden:",
} as const;

export const footerLabels = {
  text: "Der Bund der Steuerzahler setzt sich dafür ein, dass es im Zuge der Grundsteuerreform NICHT zu Steuererhöhungen kommt. Unterstützen Sie uns dabei. Werden Sie Mitglied und profitieren Sie dann auch von lukrativen Service-Vorteilen.",
  logoAlt: "Bund der Steuerzahler Logo",
};

export const socialLabels = {
  member: "Mitglied werden",
  contact: "Kontakt",
  newsletter: "Newsletter",
  facebook: "Facebook",
  twitter: "Twitter",
};

export const tooltipLabels = {
  close: "Hinweis schließen",
};
